import askGVTLogo from "@ui/icons/AskGVTLogo.svg?raw";
import askGVTLogoSmall from "@ui/icons/AskGVTLogoSmall.svg?raw";
import { useAppContext } from "@ui/layouts/layoutProvider";
import { MenuItem } from "@ui/layouts/MenuItem";
import { MenuPrimaryActions } from "@ui/layouts/MenuPrimaryActions";
import { MenuSubHeading } from "@ui/layouts/StudioLayout/components/MenuSubHeading";
import { RecentQuestions } from "@ui/layouts/StudioLayout/components/RecentQuestions";
import { SidePanelHeader } from "@ui/layouts/StudioLayout/components/SidePanelHeader";
import { For, Show } from "solid-js";
import { creatorHref } from "~/modules/askgvt/discovery/utils/creatorHref";
import { pageVars } from "../pageVars";
import { ConsumerMenuFooter } from "./ConsumerMenuFooter";

export const AskConsumerSidebar = () => {
	const { menuIsOpen } = useAppContext();
	const vars = pageVars();

	const subscriptions = () => vars.subscriptions ?? [];
	const hasMoreSubscriptions = () =>
		(vars.currentlyEntitledCreatorCount ?? subscriptions().length) >
		subscriptions().length;

	return (
		<aside
			class="side-bar askgvt1-sidebar askgvt"
			classList={{ collapsed: !menuIsOpen() }}
		>
			<SidePanelHeader
				icon={askGVTLogo}
				smallIcon={askGVTLogoSmall}
				releaseVersion="beta"
			/>

			<nav>
				<div class="askgvt1-sidebar-primary">
					<MenuPrimaryActions
						cta={{ href: "/", label: "Ask anyone", symbol: "edit_square" }}
						switchTo="studio"
					/>
					<ul>
						<MenuItem label="Discover" symbol="explore" url="/discovery" />
						<Show when={vars.isSignedIn}>
							<MenuItem label="Upload" symbol="upload" url="/studio/create" />
							<MenuItem label="Artifacts" symbol="monitoring" url="/artifacts" />
							<MenuItem label="Boards" symbol="space_dashboard" url="/boards" />
						</Show>
					</ul>
				</div>
				<Show when={vars.isSignedIn && menuIsOpen()}>
					<section class="askgvt1-sidebar-section">
						<MenuSubHeading
							label="Subscriptions"
							link="/subscriptions"
							linkLabel="View all"
						/>
						<ul>
							<For each={subscriptions()}>
								{(sub) => (
									<MenuItem
										label={
											sub.influencer.display_name ?? `@${sub.influencer.handle}`
										}
										url={creatorHref(sub.influencer.handle)}
										avatar={{
											src: sub.influencer.avatar_url,
											alt: sub.influencer.display_name ?? sub.influencer.handle,
										}}
									/>
								)}
							</For>
							<Show when={hasMoreSubscriptions()}>
								<MenuItem
									label="More"
									symbol="expand_more"
									url="/subscriptions"
								/>
							</Show>
						</ul>
					</section>
				</Show>
				<Show when={vars.isSignedIn}>
					<RecentQuestions
						class="askgvt1-sidebar-section"
						questions={vars.recentQuestions.map((question) => ({
							id: question.id,
							prompt: question.prompt,
							summary: question.summary,
							tooltip: question.name,
							progress: question.progress,
							href: question.influencer
								? `/@${question.influencer.handle}/${question.id}`
								: `/questions/${question.id}`,
						}))}
						viewAllHref="/subscriptions/questions"
					/>
				</Show>
			</nav>
			<ConsumerMenuFooter />
		</aside>
	);
};
